import { environment } from "../../../api/build";

export const determineWebSocketEnvironment = () => {
  let url: string;
  let urlNewPage: string;
  if (environment === 'production') {
    url = 'https://cloud.usf.edu/ons/api/advisorhub';
    urlNewPage = 'https://cloud.usf.edu/ons/#/admin/studentDetail/';
  
  } else if (environment.startsWith('local')) {
    url = 'https://localhost:7289/advisorhub';
    urlNewPage = "https://localhost:1236/#/admin/studentDetail/"
  } else {
    url = 'https://clouddev.usf.edu/ons/api/advisorhub';
    urlNewPage = "https://clouddev.usf.edu/ons/#/admin/studentDetail/"
  }

  return [url, urlNewPage];
}
